const formatHref = (type, match) => {
  const phoneNumber = type === 'phone'
  const mail = type === 'mail'
  const link = type === 'link'

  const formattedLink = () => {
    if (
      match?.toLowerCase().indexOf('http://') === 0 ||
      match?.toLowerCase().indexOf('https://') === 0
    ) {
      return match
    }
    return `//${match}`
  }

  const formattedPhoneNumber = () => {
    return `tel:${match?.replace(/\s/g, '')}`
  }

  return (
    (phoneNumber && formattedPhoneNumber()) ||
    (mail && `mailto:${match}`) ||
    (link && formattedLink())
  )
}

export default formatHref
